var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sub_view == 'articulos')?_c('b-row',{staticClass:"j-start"},[_c('b-col',{attrs:{"cols":"12"}},[_c('search')],1),_c('b-col',{attrs:{"cols":"12"}},[_c('article-performances')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }